import type { Period } from './schemas';

/** Resolve a period filter into a [from, to) UTC range. `from` null = unbounded. */
export function resolvePeriod(period: Period, now: Date, custom?: { from?: string; to?: string }): { from: Date | null; to: Date } {
  const startOfDay = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const end = new Date(now.getTime() + 1000);
  switch (period) {
    case 'today':
      return { from: startOfDay, to: end };
    case 'yesterday':
      return { from: new Date(startOfDay.getTime() - 86_400_000), to: startOfDay };
    case '7d':
      return { from: new Date(startOfDay.getTime() - 6 * 86_400_000), to: end };
    case '30d':
      return { from: new Date(startOfDay.getTime() - 29 * 86_400_000), to: end };
    case 'all':
      return { from: null, to: end };
    case 'custom': {
      const from = custom?.from ? new Date(`${custom.from}T00:00:00.000Z`) : startOfDay;
      const to = custom?.to ? new Date(new Date(`${custom.to}T00:00:00.000Z`).getTime() + 86_400_000) : end;
      return { from, to };
    }
  }
}

export function startOfUtcDay(now: Date): Date {
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
}
